if (!window.Eurus.loadedScript.has('custom-promo-bar.js')) {
  window.Eurus.loadedScript.add('custom-promo-bar.js');

  class CustomPromoBar extends HTMLElement {
    constructor() {
      super();
      this.tickCountdown = this.tickCountdown.bind(this);
      this.rotateSlides = this.rotateSlides.bind(this);
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-promo-bar-slide]'));
      this.initCountdown();
      this.initRotation();
    }

    disconnectedCallback() {
      clearInterval(this.countdownTimer);
      clearInterval(this.rotationTimer);
    }

    initCountdown() {
      const countdownWrap = this.querySelector('[data-promo-bar-countdown-wrap]');
      const countdownEl = this.querySelector('[data-promo-bar-countdown]');
      if (!countdownWrap || !countdownEl || !countdownWrap.dataset.promoBarYear) return;

      this.countdownWrap = countdownWrap;
      this.countdownEl = countdownEl;
      this.vipFallback = this.querySelector('[data-promo-bar-vip-fallback]');
      this.targetTime = this.computeTargetTime(countdownWrap.dataset);

      this.tickCountdown();
      if (this.remainingMs() > 0) {
        this.countdownTimer = setInterval(this.tickCountdown, 1000);
      }
    }

    computeTargetTime(data) {
      const target = new Date(
        Number(data.promoBarYear),
        Number(data.promoBarMonth) - 1,
        Number(data.promoBarDay),
        Number(data.promoBarHour),
        Number(data.promoBarMinute)
      );
      const timezoneOffsetMinutes = Number(data.promoBarTimezone) * 60;
      return target.getTime() + (-1 * timezoneOffsetMinutes - target.getTimezoneOffset()) * 60 * 1000;
    }

    remainingMs() {
      return this.targetTime - Date.now();
    }

    tickCountdown() {
      const distance = this.remainingMs();

      if (distance <= 0) {
        clearInterval(this.countdownTimer);
        this.switchToVip();
        return;
      }

      const hours = Math.floor(distance / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      this.countdownEl.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    switchToVip() {
      if (!this.vipFallback) return;
      this.countdownWrap.setAttribute('hidden', '');
      this.vipFallback.removeAttribute('hidden');
    }

    initRotation() {
      if (this.slides.length < 2) return;

      const seconds = Number(this.dataset.rotationSpeed) || 6;
      this.rotationTimer = setInterval(this.rotateSlides, seconds * 1000);
    }

    rotateSlides() {
      const activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      const nextIndex = (activeIndex + 1) % this.slides.length;

      this.slides[activeIndex]?.classList.remove('is-active');
      this.slides[nextIndex]?.classList.add('is-active');
    }
  }

  if (!customElements.get('custom-promo-bar')) {
    customElements.define('custom-promo-bar', CustomPromoBar);
  }
}
